import { BoxV2 as Box, Flex } from 'portal-commons';
import { CSSProperties, FunctionComponent } from 'react';
import {
  IconDefinition,
  faAward,
  faCircle,
  faCircleCheck,
} from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { MnoMetadata } from '@/apis/core';
import { S3_ASSETS_PATH } from '@/constants';

interface CarrierStatusProps {
  checked?: boolean;
  carrier: MnoMetadata;
  onClick?: () => void;
}

interface CheckboxProps {
  checked?: boolean;
}

interface ColumnProps {
  style?: CSSProperties;
  icon?: IconDefinition;
  title: string;
}

const Checkbox: FunctionComponent<CheckboxProps> = ({ checked }) => (
  <Flex
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      width: '36px',
      height: '36px',
      marginRight: 's',
      color: checked ? 't.blue100' : 't.black20',
      fontWeight: 300,
      fontSize: '36px',
      opacity: checked ? 1 : 0.5,
    }}
  >
    <FontAwesomeIcon icon={checked ? faCircleCheck : faCircle} />
  </Flex>
);

const Column: FunctionComponent<ColumnProps> = ({
  style,
  icon,
  title,
  children,
}) => (
  <Flex
    sx={{
      flexDirection: 'column',
      alignItems: 'center',
      height: '100%',
      ...style,
    }}
  >
    <Flex
      sx={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        gap: 'xxs',
        width: '100%',
        color: 't.blue100',
        background: 't.paleBlue300',
        fontWeight: 600,
      }}
    >
      {icon && (
        <Box sx={{ fontWeight: 400, fontSize: 'H300' }}>
          <FontAwesomeIcon icon={icon} />
        </Box>
      )}
      {title}
    </Flex>
    <Flex
      sx={{
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        color: 't.black60',
        background: 't.black05',
      }}
    >
      {children}
    </Flex>
  </Flex>
);

const CarrierStatus: FunctionComponent<CarrierStatusProps> = ({
  checked,
  carrier,
  onClick,
}) => (
  <Flex
    sx={{
      flexDirection: 'row',
      alignItems: 'center',
      width: '100%',
      height: '90px',
      fontWeight: 400,
      fontSize: 'H200',
      cursor: 'pointer',
    }}
    onClick={carrier.qualify ? onClick : undefined}
    data-testid={`CarrierStatus-${carrier.id}`}
  >
    <Checkbox checked={checked} />
    <Flex
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '124px',
        height: '100%',
        color: 't.white',
        background: 't.blue100',
      }}
    >
      {carrier.mno}
    </Flex>
    <Column
      style={{ width: '124px', marginRight: 'xxs' }}
      icon={faAward}
      title="QUALIFY"
    >
      {carrier.qualify ? (
        <Box sx={{ fontWeight: 600 }}>Yes</Box>
      ) : (
        <img src={`${S3_ASSETS_PATH}/images/not-qualify.svg`} />
      )}
    </Column>
    <Column style={{ flex: 1 }} title="BILLING CATEGORY">
      All
      {/* carrier.rbmBillingCategory ?? 'N/A' */}
    </Column>
    <Column style={{ flex: 1 }} title="FALLBACK SUPPORTED">
      Yes
      {/* typeof carrier.fallbackSupported === 'boolean'
        ? carrier.fallbackSupported
          ? 'Yes'
          : 'No'
        : 'Optional' */}
    </Column>
  </Flex>
);

export default CarrierStatus;
